import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewRef,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { first, takeUntil } from "rxjs/operators";
import { UserProfile } from "../../core/model/user-profile";
import { Direction } from "../../core/model/direction";
import { UserProfileService } from "../../core/service/user-profile.service";
import { DirectionService } from "../../core/service/direction.service";

@Component({
  selector: "app-edit-user-profile",
  templateUrl: "./edit-user-profile.component.html",
  styleUrls: ["./edit-user-profile.component.scss"],
})
export class EditUserProfileComponent implements OnInit, OnDestroy {
  pressButton: Boolean = false;
  form: FormGroup;
  loading = true;

  profileId: number;
  userprofile: UserProfile;
  directions: Direction[];

  private destroy$ = new Subject<void>();

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _userProfileService: UserProfileService,
    private _directionervice: DirectionService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required])],
      description: [null, Validators.compose([Validators.required])],
      direction: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((params: Params) => {
        this.profileId = params["profileId"];
        this.getUserProfile(this.profileId);
        this.getDirections();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getUserProfile(profileId) {
    this.loading = true;
    this._userProfileService
      .getUserProfileById(profileId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.userprofile = {
            ...data,
            direction: data.direction ? { ...data.direction } : new Direction(),
          };
          this.loading = false;
          this.safeDetectChanges();
        },
        (error) => {
          console.log(error);
          this.loading = false;
          this.safeDetectChanges();
        }
      );
  }

  getDirections() {
    this._directionervice
      .getAllDirections()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.directions = data;
          this.safeDetectChanges();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  save(): void {
    const selected = (this.directions || []).find(
      (d) => d.id === this.userprofile.direction.id
    );
    if (selected) {
      this.userprofile.direction = { ...selected };
    }
    this.pressButton = true;
    this._userProfileService
      .update(this.userprofile)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.goToList();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/user-profile");
  }

  private safeDetectChanges(): void {
    const view = this.cdr as ViewRef;
    if (view && !view.destroyed) {
      this.cdr.detectChanges();
    }
  }
}
